var drawerWidth = 260;
export var display = {
    display: "flex",
};
export var iconbutton = {
    mr: 2,
    display: { sm: "none" },
};
export var boxdrawer = {
    position: "sticky",
};
export var drawerfordesktop = {
    "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
};
export var maincomponent = {
    flexGrow: 1,
    width: { xs: "100%", sm: "calc(100% - ".concat(drawerWidth, "px)") },
    mt: "-2%",
    background: "#f6f6f7",
    maxHeight: "calc(100vh - 95px) !important",
    overflowY: "auto !important",
};
export var isLoadingCSS = {
    left: "50%",
    top: "50%",
    position: "fixed",
    zIndex: 99999999,
    animation: "none !important",
    transform: "translate(-50%, -50%)",
};
export var ST_CustName_TableCell = {
    cursor: "pointer",
    textTransform: "capitalize",
    color: "#1976d2 !important",
    textDecoration: "underline",
};
export var ST_Company_TableCell = {
    cursor: "pointer",
    textTransform: "capitalize",
    "&:hover": { backgroundColor: "#f5f5f5", color: "#1976d2 !important" },
};
export var ST_No_Cursor_Pointer = {
    textTransform: "capitalize",
    pointerEvents: "none",
};
export var ProductTableCSS = {
    padding: "10px",
    fontSize: "12px",
    whiteSpace: "nowrap",
};
export var DisplayNone = {
    display: "none",
};
export var ST_DO_SendInvoiceBtn = {
    cursor: "pointer",
    color: "#1976d2",
};
export var ST_Table_CSS = {
    width: "auto !important",
    maxHeight: 500,
    tableLayout: "fixed",
    border: "1px solid #bfbfbf",
};
export var ST_Product_Image_CSS = {
    height: 40,
    width: 40,
    borderRadius: "4px",
};
export var ST_Desktop_Display = {
    display: { xs: "none", md: "flex" },
    fontSize: "16px",
    color: "#1565C4",
    fontFamily: "'Inter', sans-serif",
};
export var ST_NavBar_SelectBox = {
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
};
export var ST_CI_Heading = {
    display: "flex",
    alignItems: "center",
};
export var ST_CI_Heading_Font = {
    fontWeight: "bold",
    fontFamily: "'Inter', sans-serif",
    fontSize: "16px",
    whiteSpace: "nowrap",
};
export var ST_CI_NoCompany_Heading = {
    fontWeight: "bold",
    fontFamily: "'Inter', sans-serif",
    whiteSpace: "nowrap",
};
export var ST_CI_PhotoRoundedIcon = {
    width: 45,
    height: 45,
    borderRadius: "50%",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};
export var ST_CI_ContactCart_PhotoRoundedIcon = {
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
};
export var ST_CI_Header_TableCell_FontSize = {
    fontSize: "13px",
};
export var ST_CI_borderRadious = {
    borderRadius: "8px",
};
export var ST_CI_Customer_Box = {
    marginTop: "26px",
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    border: "1px solid #d4d4d4",
};
export var ST_Company_Table_CSS = {
    width: "100% !important",
    maxHeight: 500,
    tableLayout: "fixed",
    border: "1px solid #D4D4D4",
};
export var ST_SalesOrder_Table = {
    width: "auto !important",
    maxHeight: 350,
    tableLayout: "fixed",
    boxShadow: "none !important",
};
export var ST_Table_Container_With_Border = {
    border: "1px solid #D4D4D4",
    background: "white",
    display: "flex",
    justifyContent: "flex-end",
    borderRadius: "8px",
};
export var ST_SearchBar_Box_CSS = {
    border: "1px solid #D4D4D4",
    background: "white",
    display: "flex",
    justifyContent: "flex-end",
    borderBottom: 0,
    borderRadius: "8px 8px 0 0",
};
export var ST_Table_Container_CSS = {
    borderRadius: "0 0 8px 8px",
    borderTop: 0,
};
export var ST_CreateOrderSection_box = {
    backgroundColor: "white",
    borderRadius: "8px",
    border: "1px solid #d4d4d4",
};
export var ST_CommonInputLable_FontSize = {
    "& .MuiInputLabel-root": { fontSize: "12px" },
};
export var ST_CommonInputBase_FontSize = {
    "& .MuiInputBase-input": { fontSize: "12px" },
};
export var ST_CS_tableContainer = {
    maxHeight: 340,
    border: "0.1px solid #bfbfbf",
    borderRadius: "8px",
    marginTop: "30px",
    "& th": {
        fontSize: "13px !important",
    },
    "& td": {
        padding: "2px !important",
    },
};
export var customerPopUpTable = {
    border: "1px solid #D4D4D4",
    width: "auto !important",
    maxHeight: 400,
    tableLayout: "fixed",
    borderRadius: "8px",
};
export var ST_AllOrdersTable = {
    width: "auto !important",
    maxHeight: 500,
    tableLayout: "fixed",
    boxShadow: "none !important",
};
export var ST_LastChield_Border = {
    "& tr:last-child td": {
        borderBottom: "0px !important",
    },
};
export var ST_MyCustomerPagination_CSS = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    backgroundColor: "white",
    padding: "10px",
    border: "1px solid #D4D4D4",
    borderRadius: "0 0 8px 8px",
    borderTop: "0px",
};
